import React, {Component} from "react";
import {Redirect} from "react-router";
import {Grid, Row, Col, Nav, NavItem, FormGroup, ControlLabel, FormControl, Badge} from "react-bootstrap";
import Switch from "components/CustomSwitch";
import Select from "react-select";
import "react-select/dist/react-select.css";
import "react-dual-listbox/lib/react-dual-listbox.css";
import apiClient from "api/client";
import connect from "react-redux/es/connect/connect";
import NotificationSystem from "react-notification-system";
import DualListBox from "react-dual-listbox";
import TagsInput from "react-tagsinput";
import Card from "../../components/Card/Card.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";
import ModalSave from "../../components/CustomModals/ModalSave";
import PlaylistScaffoldNotice from "../../components/Playlists/PlaylistScaffoldNotice.jsx";
import PlaylistScaffoldTable from "../../components/Playlists/PlaylistScaffoldTable.jsx";
import {DropDownCountries} from "../../components/CustomDropDown/DropDownCountries";
import {userActions} from "../../authentication/_actions";
import {style} from "../../variables/Variables";
import {playlistArray} from "../../variables/PlaylistVariables";
import {
    formatCategoryScope,
    formatPlaylistType,
    formatViewershipMode,
    playlistDeliveryOptions,
    playlistTypeOptions,
    viewershipModeOptions
} from "../../components/Playlists/playlistScaffoldData";
import {withNamespaces} from "react-i18next";

const playlistOrderingRuleOptions = [
    {value: "manual", label: "Manual"},
    {value: "editorial", label: "Editorial"},
    {value: "schedule", label: "Scheduled"},
    {value: "popularity", label: "Popularity"},
    {value: "pinned", label: "Pinned"},
    {value: "fallback", label: "Fallback"}
];

const playlistPositionOrderOptions = [
    {value: "date_published", label: "Date published"},
    {value: "most_popular", label: "Most popular"},
    {value: "date_added", label: "Date added"},
    {value: "manually_sorted", label: "Manually sorted"}
];

const playlistVisibilityOptions = [
    {value: "private", label: "Private"},
    {value: "public", label: "Public"},
    {value: "unlisted", label: "Unlisted"}
];

const defaultPlaylist = () => ({
    playlist_id: "new",
    playlist_status: 1,
    playlist_position: 1,
    playlist_name: "",
    playlist_short_name: "",
    playlist_long_name: "",
    playlist_slug: "",
    playlist_description: "",
    playlist_type: "sports",
    playlist_delivery: "hybrid",
    playlist_creator_user_id: "",
    playlist_creator_name: "",
    playlist_category_ids: [],
    playlist_category_names: [],
    playlist_categories: [],
    playlist_package_ids: [],
    playlist_package_names: [],
    playlist_packages: [],
    items: [],
    playlist_item_count: 0,
    playlist_viewership_mode: "private",
    playlist_viewership_summary: "",
    playlist_geo_policy: "",
    playlist_device_targets: "",
    playlist_sort_mode: "manually_sorted",
    playlist_max_items: 20,
    playlist_auto_play: 0,
    playlist_visibility: "private",
    playlist_share_with_viewers: [],
    playlist_country_block_status: 0,
    playlist_country_block_countries: [],
    playlist_tags: [],
    custom_data: {}
});

class EditPlaylist extends Component {

    constructor(props) {
        super(props);

        this.state = {
            _notificationSystem: null,
            loading: false,
            contentLoading: false,
            showSaveModal: false,
            redirect: false,
            playlistRedirect: false,
            back_button_text: "Cancel",
            playlist: defaultPlaylist(),
            creatorOptions: [],
            categoryOptions: [],
            packageOptions: [],
            assignableContentOptions: [],
            pendingContentSelection: []
        };
    }

    componentDidMount() {
        this.setState({_notificationSystem: this.refs.notificationSystem}, this.loadPageData);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.handle !== this.props.match.params.handle) {
            this.loadPageData();
        }
    }

    getAxiosConfig = () => {
        let user = this.getCurrentUser();

        if (!user || !user.token) {
            this.props.dispatch(userActions.logoutUnauthorized());
            return null;
        }

        return {
            headers: {
                "X-Id-Token": user.token,
                "Content-Type": "application/json"
            }
        };
    }

    getCurrentUser = () => {
        try {
            return JSON.parse(localStorage.getItem("user"));
        } catch (error) {
            return null;
        }
    }

    handleApiError = (error) => {
        this.setState({
            loading: false,
            contentLoading: false,
            showSaveModal: false
        });

        if (error && error.response && error.response.status === 401) {
            this.props.dispatch(userActions.logoutUnauthorized(error));
            return;
        }

        this.notification("failed");
        console.log(error);
    }

    parseCustomData = (customData) => {
        if (!customData) {
            return {};
        }

        if (typeof customData === "object" && !Array.isArray(customData)) {
            return customData;
        }

        if (typeof customData === "string") {
            try {
                const parsedValue = JSON.parse(customData);
                return parsedValue && typeof parsedValue === "object" ? parsedValue : {};
            } catch (error) {
                return {};
            }
        }

        return {};
    }

    normalizeStringList = (value) => {
        if (Array.isArray(value)) {
            return value
                .map((entry) => String(entry).trim())
                .filter((entry) => entry !== "");
        }

        if (typeof value === "string") {
            return value
                .split(",")
                .map((entry) => entry.trim())
                .filter((entry) => entry !== "");
        }

        return [];
    }

    normalizeBinaryFlag = (value) => {
        return value === true || value === 1 || value === "1" ? 1 : 0;
    }

    normalizeSortMode = (sortMode) => {
        const sortModeMap = {
            manual: "manually_sorted",
            popularity: "most_popular",
            editorial: "date_added",
            schedule: "date_published"
        };

        return sortModeMap[sortMode] || sortMode || "manually_sorted";
    }

    normalizePlaylistRecord = (record = {}) => {
        const customData = this.parseCustomData(record.custom_data);
        const categoryIds = Array.isArray(record.playlist_category_ids)
            ? record.playlist_category_ids.map((value) => String(value))
            : [];
        const packageIds = Array.isArray(record.playlist_package_ids)
            ? record.playlist_package_ids.map((value) => String(value))
            : [];
        const categoryNames = Array.isArray(record.playlist_category_names) ? record.playlist_category_names : [];
        const packageNames = Array.isArray(record.playlist_package_names) ? record.playlist_package_names : [];
        const playlistItems = Array.isArray(record.items)
            ? record.items
            : (Array.isArray(record.playlist_items) ? record.playlist_items : []);
        const shareWithViewers = this.normalizeStringList(customData.playlist_share_with_viewers || record.playlist_viewership_summary);
        const countryBlockCountries = this.normalizeStringList(customData.playlist_country_block_countries || record.playlist_geo_policy);
        const tags = this.normalizeStringList(customData.playlist_tags || record.playlist_device_targets);
        const visibility = customData.playlist_visibility || record.playlist_viewership_mode || "private";

        return {
            playlist_id: record.playlist_id || "new",
            playlist_status: Number(record.playlist_status) === 1 ? 1 : 0,
            playlist_position: record.playlist_position || 1,
            playlist_name: record.playlist_name || "",
            playlist_short_name: customData.playlist_short_name || record.playlist_name || "",
            playlist_long_name: customData.playlist_long_name || record.playlist_name || "",
            playlist_slug: record.playlist_slug || "",
            playlist_description: record.playlist_description || "",
            playlist_type: record.playlist_type || "sports",
            playlist_delivery: record.playlist_delivery || "hybrid",
            playlist_creator_user_id: record.playlist_creator_user_id !== undefined && record.playlist_creator_user_id !== null ? String(record.playlist_creator_user_id) : "",
            playlist_creator_name: record.playlist_creator_name || "",
            playlist_category_ids: categoryIds,
            playlist_category_names: categoryNames,
            playlist_categories: Array.isArray(record.playlist_categories) ? record.playlist_categories : [],
            playlist_package_ids: packageIds,
            playlist_package_names: packageNames,
            playlist_packages: Array.isArray(record.playlist_packages) ? record.playlist_packages : [],
            items: this.normalizePlaylistItems(playlistItems),
            playlist_item_count: record.playlist_item_count || playlistItems.length || 0,
            playlist_viewership_mode: visibility,
            playlist_viewership_summary: shareWithViewers.join(", "),
            playlist_geo_policy: countryBlockCountries.join(", "),
            playlist_device_targets: tags.join(", "),
            playlist_sort_mode: this.normalizeSortMode(record.playlist_sort_mode),
            playlist_max_items: record.playlist_max_items !== undefined && record.playlist_max_items !== null ? record.playlist_max_items : 20,
            playlist_auto_play: this.normalizeBinaryFlag(customData.playlist_auto_play),
            playlist_visibility: visibility,
            playlist_share_with_viewers: shareWithViewers,
            playlist_country_block_status: this.normalizeBinaryFlag(customData.playlist_country_block_status || (countryBlockCountries.length > 0 ? 1 : 0)),
            playlist_country_block_countries: countryBlockCountries,
            playlist_tags: tags,
            custom_data: customData
        };
    }

    normalizePlaylistItems = (items = []) => {
        return items.map((item, index) => ({
            playlist_item_id: item.playlist_item_id || null,
            playlist_order: item.playlist_order !== undefined && item.playlist_order !== null ? item.playlist_order : (index + 1),
            content_type: item.content_type || "",
            content_id: item.content_id !== undefined && item.content_id !== null ? String(item.content_id) : "",
            content_title: item.content_title || "",
            playlist_category_id: item.playlist_category_id !== undefined && item.playlist_category_id !== null ? String(item.playlist_category_id) : "",
            availability: item.availability || "",
            ordering_rule: item.ordering_rule || "manual",
            start_window: item.start_window || "",
            end_window: item.end_window || ""
        }));
    }

    buildCategoryOptions = (categories = []) => {
        return categories.map((category) => ({
            value: String(category.playlist_category_id),
            label: category.playlist_category_name,
            playlist_type: category.playlist_type,
            scope: category.playlist_category_scope,
            playlist_count: category.playlist_count || 0
        }));
    }

    buildCreatorOptions = (creators = []) => {
        return creators.map((creator) => ({
            value: String(creator.value),
            label: creator.label || creator.creator_name,
            creator_name: creator.creator_name,
            content_count: creator.content_count || 0,
            category_count: creator.category_count || 0,
            package_count: creator.package_count || 0
        }));
    }

    buildPackageOptions = (packages = []) => {
        return packages.map((pkg) => ({
            value: String(pkg.value),
            label: pkg.label,
            package_type: pkg.package_type,
            package_id: pkg.package_id
        }));
    }

    buildAssignableContentOptions = (content = []) => {
        return content.map((entry) => ({
            value: this.getItemKey(entry.content_type, entry.value),
            label: entry.label,
            content_type: entry.content_type,
            content_id: String(entry.value)
        }));
    }

    getItemKey = (contentType, contentId) => {
        return String(contentType) + ":" + String(contentId);
    }

    matchesPlaylistType = (candidateType, playlistType = this.state.playlist.playlist_type) => {
        if (playlistType === "vod") {
            return ["vod", "svod_movies", "svod_series"].includes(candidateType);
        }

        return candidateType === playlistType;
    }

    getFilteredCategoryOptions = () => {
        return this.state.categoryOptions.filter((option) => this.matchesPlaylistType(option.playlist_type));
    }

    fetchCreatorOptions = (axiosConfig) => {
        return apiClient.get(process.env.REACT_APP_API_URL + "/CcPlaylists/content-creators", axiosConfig)
            .then((res) => this.buildCreatorOptions(Array.isArray(res.data) ? res.data : []));
    }

    fetchCategoryOptions = (playlistType, creatorUserId, axiosConfig) => {
        let dataUrl = process.env.REACT_APP_API_URL + "/CcPlaylistCategories";
        const query = [];

        if (playlistType) {
            query.push("playlist_type=" + encodeURIComponent(playlistType));
        }

        if (creatorUserId) {
            query.push("creator_user_id=" + encodeURIComponent(creatorUserId));
        }

        if (query.length > 0) {
            dataUrl += "?" + query.join("&");
        }

        return apiClient.get(dataUrl, axiosConfig)
            .then((res) => this.buildCategoryOptions(Array.isArray(res.data) ? res.data : []));
    }

    fetchPackageOptions = (playlistType, creatorUserId, axiosConfig) => {
        let dataUrl = process.env.REACT_APP_API_URL + "/CcPlaylists/packages";
        const query = [];

        if (playlistType) {
            query.push("playlist_type=" + encodeURIComponent(playlistType));
        }

        if (creatorUserId) {
            query.push("creator_user_id=" + encodeURIComponent(creatorUserId));
        }

        if (query.length > 0) {
            dataUrl += "?" + query.join("&");
        }

        return apiClient.get(dataUrl, axiosConfig)
            .then((res) => this.buildPackageOptions(Array.isArray(res.data) ? res.data : []));
    }

    applyScopedOptionsToPlaylist = (playlist, categoryOptions = [], packageOptions = []) => {
        const validCategoryIds = playlist.playlist_category_ids.filter((value) => categoryOptions.some((option) => option.value === value));
        const validPackageIds = playlist.playlist_package_ids.filter((value) => packageOptions.some((option) => option.value === value));

        return {
            ...playlist,
            playlist_category_ids: validCategoryIds,
            playlist_category_names: categoryOptions
                .filter((option) => validCategoryIds.includes(option.value))
                .map((option) => option.label),
            playlist_categories: categoryOptions
                .filter((option) => validCategoryIds.includes(option.value))
                .map((option, index) => ({
                    playlist_category_id: option.value,
                    playlist_category_name: option.label,
                    playlist_type: option.playlist_type,
                    position: index
                })),
            playlist_package_ids: validPackageIds,
            playlist_package_names: packageOptions
                .filter((option) => validPackageIds.includes(option.value))
                .map((option) => option.label),
            playlist_packages: packageOptions
                .filter((option) => validPackageIds.includes(option.value)),
            items: playlist.items.map((item) => ({
                ...item,
                playlist_category_id: item.playlist_category_id && validCategoryIds.includes(String(item.playlist_category_id))
                    ? String(item.playlist_category_id)
                    : (validCategoryIds[0] || "")
            }))
        };
    }

    sortItems = (items = []) => {
        return [...items].sort((a, b) => {
            const orderA = parseInt(a.playlist_order, 10) || 0;
            const orderB = parseInt(b.playlist_order, 10) || 0;

            if (orderA !== orderB) {
                return orderA - orderB;
            }

            return this.getItemKey(a.content_type, a.content_id).localeCompare(this.getItemKey(b.content_type, b.content_id));
        });
    }

    loadPageData = () => {
        const {handle} = this.props.match.params;
        const axiosConfig = this.getAxiosConfig();

        if (!axiosConfig) {
            return;
        }

        this.setState({
            loading: true,
            contentLoading: false,
            showSaveModal: false,
            redirect: false,
            playlistRedirect: false,
            back_button_text: handle === "new" ? "Cancel" : "Back"
        });

        if (handle === "new") {
            Promise.all([
                apiClient.get(process.env.REACT_APP_API_URL + "/CcPlaylists/position", axiosConfig),
                this.fetchCreatorOptions(axiosConfig)
            ]).then(([positionRes, creatorOptions]) => {
                const nextPosition = Array.isArray(positionRes.data) && positionRes.data[0] ? positionRes.data[0].PlaylistPosition : 1;
                const currentUser = this.getCurrentUser();
                const playlist = {
                    ...defaultPlaylist(),
                    playlist_position: nextPosition || 1,
                    playlist_creator_user_id: currentUser && currentUser.level === "content_creator" ? String(currentUser.id) : "",
                    playlist_creator_name: currentUser && currentUser.level === "content_creator"
                        ? [currentUser.firstName, currentUser.lastName].filter((value) => !!value).join(" ")
                        : ""
                };

                return Promise.all([
                    this.fetchCategoryOptions(playlist.playlist_type, playlist.playlist_creator_user_id, axiosConfig),
                    this.fetchPackageOptions(playlist.playlist_type, playlist.playlist_creator_user_id, axiosConfig)
                ]).then(([categoryOptions, packageOptions]) => {
                    this.setState({
                        playlist: this.applyScopedOptionsToPlaylist(playlist, categoryOptions, packageOptions),
                        creatorOptions,
                        categoryOptions,
                        packageOptions,
                        pendingContentSelection: [],
                        loading: false
                    }, () => {
                        this.fetchAssignableContent(this.state.playlist.playlist_type, this.state.playlist.playlist_creator_user_id);
                    });
                });
            }).catch(this.handleApiError);

            return;
        }

        Promise.all([
            apiClient.get(process.env.REACT_APP_API_URL + "/CcPlaylists/" + handle, axiosConfig),
            this.fetchCreatorOptions(axiosConfig)
        ]).then(([playlistRes, creatorOptions]) => {
            const playlistRecord = Array.isArray(playlistRes.data) && playlistRes.data[0] ? playlistRes.data[0] : defaultPlaylist();
            const playlist = this.normalizePlaylistRecord(playlistRecord);

            return Promise.all([
                this.fetchCategoryOptions(playlist.playlist_type, playlist.playlist_creator_user_id, axiosConfig),
                this.fetchPackageOptions(playlist.playlist_type, playlist.playlist_creator_user_id, axiosConfig)
            ]).then(([categoryOptions, packageOptions]) => {
                const scopedPlaylist = this.applyScopedOptionsToPlaylist(playlist, categoryOptions, packageOptions);

                this.setState({
                    playlist: scopedPlaylist,
                    creatorOptions,
                    categoryOptions,
                    packageOptions,
                    pendingContentSelection: scopedPlaylist.items.map((item) => this.getItemKey(item.content_type, item.content_id)),
                    loading: false
                }, () => {
                    this.fetchAssignableContent(scopedPlaylist.playlist_type, scopedPlaylist.playlist_creator_user_id);
                });
            });
        }).catch(this.handleApiError);
    }

    fetchAssignableContent = (playlistType, creatorUserId = "") => {
        const axiosConfig = this.getAxiosConfig();

        if (!axiosConfig || !playlistType) {
            return;
        }

        this.setState({contentLoading: true});

        apiClient.post(process.env.REACT_APP_API_URL + "/CcPlaylists", {
            type: "getContent",
            content_type: playlistType,
            content_creator_user_id: creatorUserId || null
        }, axiosConfig).then((res) => {
            const assignableContentOptions = this.buildAssignableContentOptions(Array.isArray(res.data) ? res.data : []);
            const validPendingSelection = this.state.pendingContentSelection.filter((value) => assignableContentOptions.some((option) => option.value === value));

            this.setState({
                assignableContentOptions,
                pendingContentSelection: validPendingSelection,
                contentLoading: false
            });
        }).catch(this.handleApiError);
    }

    handleInputChange = (event) => {
        const {name, value} = event.target;

        this.setState((prevState) => ({
            playlist: {
                ...prevState.playlist,
                [name]: value
            }
        }));
    }

    handleSwitch = (name, value) => {
        this.setState((prevState) => ({
            playlist: {
                ...prevState.playlist,
                [name]: value ? 1 : 0
            }
        }));
    }

    handlePlaylistTypeChange = (event) => {
        const nextType = event.target.value;
        const axiosConfig = this.getAxiosConfig();

        if (!axiosConfig) {
            return;
        }

        this.setState((prevState) => ({
            playlist: {
                ...prevState.playlist,
                playlist_type: nextType,
                playlist_category_ids: [],
                playlist_category_names: [],
                playlist_categories: [],
                playlist_package_ids: [],
                playlist_package_names: [],
                playlist_packages: [],
                items: [],
                playlist_item_count: 0
            },
            pendingContentSelection: []
        }), () => {
            Promise.all([
                this.fetchCategoryOptions(nextType, this.state.playlist.playlist_creator_user_id, axiosConfig),
                this.fetchPackageOptions(nextType, this.state.playlist.playlist_creator_user_id, axiosConfig)
            ]).then(([categoryOptions, packageOptions]) => {
                this.setState((prevState) => ({
                    playlist: this.applyScopedOptionsToPlaylist(prevState.playlist, categoryOptions, packageOptions),
                    categoryOptions,
                    packageOptions
                }), () => {
                    this.fetchAssignableContent(nextType, this.state.playlist.playlist_creator_user_id);
                });
            }).catch(this.handleApiError);
        });
    }

    handleCreatorSelection = (creatorOption) => {
        const axiosConfig = this.getAxiosConfig();
        const creatorId = creatorOption ? String(creatorOption.value) : "";
        const creatorName = creatorOption ? creatorOption.creator_name || creatorOption.label : "";

        if (!axiosConfig) {
            return;
        }

        this.setState((prevState) => ({
            playlist: {
                ...prevState.playlist,
                playlist_creator_user_id: creatorId,
                playlist_creator_name: creatorName,
                playlist_category_ids: [],
                playlist_category_names: [],
                playlist_categories: [],
                playlist_package_ids: [],
                playlist_package_names: [],
                playlist_packages: [],
                items: [],
                playlist_item_count: 0
            },
            pendingContentSelection: []
        }), () => {
            Promise.all([
                this.fetchCategoryOptions(this.state.playlist.playlist_type, creatorId, axiosConfig),
                this.fetchPackageOptions(this.state.playlist.playlist_type, creatorId, axiosConfig)
            ]).then(([categoryOptions, packageOptions]) => {
                this.setState((prevState) => ({
                    playlist: this.applyScopedOptionsToPlaylist(prevState.playlist, categoryOptions, packageOptions),
                    categoryOptions,
                    packageOptions
                }), () => {
                    this.fetchAssignableContent(this.state.playlist.playlist_type, creatorId);
                });
            }).catch(this.handleApiError);
        });
    }

    handleCategorySelection = (selectedOptions) => {
        const options = Array.isArray(selectedOptions) ? selectedOptions : [];
        const categoryIds = options.map((option) => option.value);
        const categoryNames = options.map((option) => option.label);

        this.setState((prevState) => ({
            playlist: {
                ...prevState.playlist,
                playlist_category_ids: categoryIds,
                playlist_category_names: categoryNames,
                playlist_categories: options.map((option, index) => ({
                    playlist_category_id: option.value,
                    playlist_category_name: option.label,
                    playlist_type: option.playlist_type,
                    position: index
                })),
                items: prevState.playlist.items.map((item) => ({
                    ...item,
                    playlist_category_id: categoryIds.includes(String(item.playlist_category_id))
                        ? String(item.playlist_category_id)
                        : (categoryIds[0] || "")
                }))
            }
        }));
    }

    handlePackageSelection = (selectedOptions) => {
        const options = Array.isArray(selectedOptions) ? selectedOptions : [];

        this.setState((prevState) => ({
            playlist: {
                ...prevState.playlist,
                playlist_package_ids: options.map((option) => option.value),
                playlist_package_names: options.map((option) => option.label),
                playlist_packages: options
            }
        }));
    }

    handleContentSelection = (selected) => {
        this.setState({
            pendingContentSelection: Array.isArray(selected) ? selected : []
        });
    }

    applySelectedContent = () => {
        this.setState((prevState) => {
            const existingItems = {};
            prevState.playlist.items.forEach((item) => {
                existingItems[this.getItemKey(item.content_type, item.content_id)] = item;
            });

            const firstCategoryId = prevState.playlist.playlist_category_ids.length > 0 ? prevState.playlist.playlist_category_ids[0] : "";
            const selectedOptions = prevState.pendingContentSelection
                .map((selectedKey) => prevState.assignableContentOptions.find((option) => option.value === selectedKey))
                .filter((option) => !!option);

            const items = selectedOptions.map((option, index) => {
                const key = option.value;
                const existingItem = existingItems[key];

                if (existingItem) {
                    return {
                        ...existingItem,
                        playlist_order: existingItem.playlist_order || (index + 1)
                    };
                }

                return {
                    playlist_item_id: null,
                    playlist_order: index + 1,
                    content_type: option.content_type,
                    content_id: option.content_id,
                    content_title: option.label,
                    playlist_category_id: firstCategoryId,
                    availability: "",
                    ordering_rule: "manual",
                    start_window: "",
                    end_window: ""
                };
            });

            return {
                playlist: {
                    ...prevState.playlist,
                    items: this.sortItems(items),
                    playlist_item_count: items.length
                }
            };
        });
    }

    handleShareWithViewersChange = (playlist_share_with_viewers) => {
        this.setState((prevState) => ({
            playlist: {
                ...prevState.playlist,
                playlist_share_with_viewers
            }
        }));
    }

    handleTagsChange = (playlist_tags) => {
        this.setState((prevState) => ({
            playlist: {
                ...prevState.playlist,
                playlist_tags
            }
        }));
    }

    handleCountryBlockSelect = (selectedCountries) => {
        const countryCodes = Array.isArray(selectedCountries)
            ? selectedCountries.map((country) => country.value)
            : [];

        this.setState((prevState) => ({
            playlist: {
                ...prevState.playlist,
                playlist_country_block_countries: countryCodes
            }
        }));
    }

    handlePlaylistItemChange = (itemKey, field, value) => {
        this.setState((prevState) => ({
            playlist: {
                ...prevState.playlist,
                items: prevState.playlist.items.map((item) => {
                    if (this.getItemKey(item.content_type, item.content_id) !== itemKey) {
                        return item;
                    }

                    return {
                        ...item,
                        [field]: value
                    };
                })
            }
        }));
    }

    removePlaylistItem = (itemKey) => {
        this.setState((prevState) => {
            const items = prevState.playlist.items.filter((item) => this.getItemKey(item.content_type, item.content_id) !== itemKey);

            return {
                pendingContentSelection: prevState.pendingContentSelection.filter((value) => value !== itemKey),
                playlist: {
                    ...prevState.playlist,
                    items,
                    playlist_item_count: items.length
                }
            };
        });
    }

    setRedirect = () => {
        this.setState({redirect: true});
    }

    setPlaylistRedirect = (playlistId) => {
        this.setState({
            playlistRedirect: true,
            back_button_text: "Back",
            playlist: {
                ...this.state.playlist,
                playlist_id: playlistId
            }
        });
    }

    buildPayload = () => {
        const playlist = this.state.playlist;
        const items = this.sortItems(playlist.items).map((item) => ({
            playlist_item_id: item.playlist_item_id,
            playlist_order: parseInt(item.playlist_order, 10) || 0,
            content_type: item.content_type,
            content_id: parseInt(item.content_id, 10),
            content_title: item.content_title,
            playlist_category_id: item.playlist_category_id ? parseInt(item.playlist_category_id, 10) : null,
            availability: item.availability,
            ordering_rule: item.ordering_rule,
            start_window: item.start_window,
            end_window: item.end_window
        }));
        const customData = {
            ...(playlist.custom_data || {}),
            playlist_short_name: playlist.playlist_short_name,
            playlist_long_name: playlist.playlist_long_name,
            playlist_auto_play: Number(playlist.playlist_auto_play) === 1 ? 1 : 0,
            playlist_visibility: playlist.playlist_visibility,
            playlist_share_with_viewers: Array.isArray(playlist.playlist_share_with_viewers) ? playlist.playlist_share_with_viewers : [],
            playlist_country_block_status: Number(playlist.playlist_country_block_status) === 1 ? 1 : 0,
            playlist_country_block_countries: Array.isArray(playlist.playlist_country_block_countries) ? playlist.playlist_country_block_countries : [],
            playlist_tags: Array.isArray(playlist.playlist_tags) ? playlist.playlist_tags : []
        };
        const shortName = playlist.playlist_short_name || playlist.playlist_long_name || playlist.playlist_name;
        const shareWithViewers = Array.isArray(playlist.playlist_share_with_viewers) ? playlist.playlist_share_with_viewers.join(", ") : "";
        const countryBlockCountries = Array.isArray(playlist.playlist_country_block_countries) ? playlist.playlist_country_block_countries.join(",") : "";
        const tags = Array.isArray(playlist.playlist_tags) ? playlist.playlist_tags.join(", ") : "";

        return {
            playlist: {
                playlist_id: playlist.playlist_id === "new" ? null : playlist.playlist_id,
                playlist_status: Number(playlist.playlist_status) === 1 ? 1 : 0,
                playlist_position: parseInt(playlist.playlist_position, 10) || 1,
                playlist_name: shortName,
                playlist_slug: playlist.playlist_slug || shortName,
                playlist_description: playlist.playlist_description,
                playlist_type: playlist.playlist_type,
                playlist_delivery: playlist.playlist_delivery,
                playlist_creator_user_id: playlist.playlist_creator_user_id ? parseInt(playlist.playlist_creator_user_id, 10) : null,
                playlist_sort_mode: playlist.playlist_sort_mode,
                playlist_max_items: parseInt(playlist.playlist_max_items, 10) || 0,
                playlist_viewership_mode: playlist.playlist_visibility,
                playlist_viewership_summary: shareWithViewers,
                playlist_geo_policy: Number(playlist.playlist_country_block_status) === 1 ? countryBlockCountries : "",
                playlist_device_targets: tags,
                playlist_category_ids: playlist.playlist_category_ids.map((value) => parseInt(value, 10)),
                playlist_package_ids: playlist.playlist_package_ids,
                playlist_items: items,
                custom_data: customData
            }
        };
    }

    savePlaylist = () => {
        const {handle} = this.props.match.params;
        const axiosConfig = this.getAxiosConfig();

        if (!axiosConfig) {
            return;
        }

        this.setState({loading: true});

        const payload = this.buildPayload();

        if (handle === "new") {
            apiClient.post(process.env.REACT_APP_API_URL + "/CcPlaylists", payload, axiosConfig)
                .then((res) => {
                    const playlistId = res.data && res.data.playlist_id ? res.data.playlist_id : null;

                    this.setState({
                        loading: false,
                        showSaveModal: false
                    });
                    this.notification("success");

                    if (playlistId) {
                        this.setPlaylistRedirect(playlistId);
                    }
                })
                .catch(this.handleApiError);
        } else {
            apiClient.put(process.env.REACT_APP_API_URL + "/CcPlaylists", payload, axiosConfig)
                .then(() => {
                    this.setState({
                        loading: false,
                        showSaveModal: false
                    });
                    this.notification("success");
                    this.loadPageData();
                })
                .catch(this.handleApiError);
        }
    }

    setSaveModal = (value, action) => {
        this.setState({showSaveModal: value});

        if (action === "save") {
            this.savePlaylist();
        }
    }

    renderSaveModal = () => {
        if (this.state.showSaveModal) {
            return <ModalSave
                headerMessage={"Playlist: "}
                bodyMessage={"this action will save all changes, click close to cancel saving"}
                handlerFromParent={this.setSaveModal}
                handlerID={this.state.playlist.playlist_id}
            />;
        }
    }

    renderRedirect = () => {
        if (this.state.redirect) {
            return <Redirect push to="/playlists/manage"/>;
        }

        if (this.state.playlistRedirect) {
            return <Redirect push to={"/playlists/edit/" + this.state.playlist.playlist_id}/>;
        }
    }

    notification = (status) => {
        if (!this.state._notificationSystem) {
            return;
        }

        if (status === "success") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-check"/>),
                message: (
                    <div>
                        <b>Playlist has been updated</b>
                    </div>
                ),
                level: "success",
                position: "tr",
                autoDismiss: 5
            });
        }

        if (status === "failed") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-times"/>),
                message: (
                    <div>
                        <b>Failed to save playlist</b>
                    </div>
                ),
                level: "error",
                position: "tr",
                autoDismiss: 8
            });
        }
    }

    title = () => {
        const title = this.state.playlist.playlist_long_name || this.state.playlist.playlist_short_name || this.state.playlist.playlist_name;

        if (!title) {
            return "New Playlist";
        }

        return title + " - Playlist";
    }

    renderCountryBlockFields = () => {
        if (this.state.playlist.playlist_country_block_status !== 1) {
            return null;
        }

        return (
            <FormGroup>
                <ControlLabel>Country Block</ControlLabel>
                <DropDownCountries
                    countrySelected={this.state.playlist.playlist_country_block_countries}
                    name='playlistCountryBlockSelect'
                    handlerFromParent={this.handleCountryBlockSelect}
                    hadlerAddAllCountries={false}
                />
            </FormGroup>
        );
    }

    renderPrivateOptions = () => {
        if (this.state.playlist.playlist_visibility !== "private") {
            return null;
        }

        return (
            <div>
                <legend style={{marginTop: "20px"}}>Private Options</legend>
                <FormGroup>
                    <ControlLabel>Share With Viewers</ControlLabel>
                    <TagsInput
                        value={this.state.playlist.playlist_share_with_viewers}
                        disabled={this.state.loading}
                        onChange={this.handleShareWithViewersChange}
                        tagProps={{className: "react-tagsinput-tag tag-fill tag-blue"}}
                    />
                </FormGroup>
            </div>
        );
    }

    renderPlaylistInformationCard = () => {
        const playlist = this.state.playlist;
        const categoryOptions = this.getFilteredCategoryOptions();
        const currentUser = this.getCurrentUser();
        const creatorSelectionDisabled = currentUser && currentUser.level === "content_creator";

        return (
            <Card
                content={
                    <div>
                        <h5>Playlist Information</h5>
                        <legend/>
                        <div className="buttons-with-margin" style={{marginBottom: "20px"}}>
                            <Button
                                bsStyle="info"
                                fill
                                onClick={() => this.setState({showSaveModal: true})}
                                disabled={this.state.loading}
                            >
                                Save
                            </Button>
                            <Button
                                bsStyle="default"
                                fill
                                onClick={this.setRedirect}
                                disabled={this.state.loading}
                            >
                                Back
                            </Button>
                            <Button
                                bsStyle="success"
                                fill
                                onClick={this.applySelectedContent}
                                disabled={this.state.loading || this.state.contentLoading || this.state.pendingContentSelection.length === 0}
                            >
                                Add Video
                            </Button>
                        </div>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>Playlist Type</ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        name="playlist_type"
                                        value={playlist.playlist_type}
                                        onChange={this.handlePlaylistTypeChange}
                                        disabled={this.state.loading}
                                    >
                                        {playlistTypeOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </FormControl>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>Position Order</ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        name="playlist_sort_mode"
                                        value={playlist.playlist_sort_mode}
                                        onChange={this.handleInputChange}
                                        disabled={this.state.loading}
                                    >
                                        {playlistPositionOrderOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </FormControl>
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <ControlLabel>Playlist Creator</ControlLabel>
                            <Select
                                name="playlistCreatorSelect"
                                searchable={true}
                                clearable={!creatorSelectionDisabled}
                                disabled={this.state.loading || creatorSelectionDisabled}
                                value={playlist.playlist_creator_user_id}
                                options={this.state.creatorOptions}
                                onChange={this.handleCreatorSelection}
                            />
                        </FormGroup>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>Short Name</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="playlist_short_name"
                                        value={playlist.playlist_short_name}
                                        onChange={this.handleInputChange}
                                        placeholder="Enter short name"
                                        disabled={this.state.loading}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>Long Name</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="playlist_long_name"
                                        value={playlist.playlist_long_name}
                                        onChange={this.handleInputChange}
                                        placeholder="Enter long name"
                                        disabled={this.state.loading}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <ControlLabel>Description</ControlLabel>
                            <FormControl
                                componentClass="textarea"
                                rows={4}
                                name="playlist_description"
                                value={playlist.playlist_description}
                                onChange={this.handleInputChange}
                                placeholder="Enter description"
                                disabled={this.state.loading}
                            />
                        </FormGroup>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>Status</ControlLabel>
                                    <br/>
                                    <Switch
                                        value={playlist.playlist_status === 1}
                                        onChange={(el, value) => this.handleSwitch("playlist_status", value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>Auto Play</ControlLabel>
                                    <br/>
                                    <Switch
                                        value={playlist.playlist_auto_play === 1}
                                        onChange={(el, value) => this.handleSwitch("playlist_auto_play", value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <FormGroup>
                            <ControlLabel>Categories</ControlLabel>
                            <Select
                                name="playlistCategorySelect"
                                multi={true}
                                searchable={true}
                                clearable={false}
                                disabled={this.state.loading}
                                value={playlist.playlist_category_ids}
                                options={categoryOptions}
                                onChange={this.handleCategorySelection}
                            />
                        </FormGroup>

                        <FormGroup>
                            <ControlLabel>Packages</ControlLabel>
                            <Select
                                name="playlistPackageSelect"
                                multi={true}
                                searchable={true}
                                clearable={false}
                                disabled={this.state.loading}
                                value={playlist.playlist_package_ids}
                                options={this.state.packageOptions}
                                onChange={this.handlePackageSelection}
                            />
                        </FormGroup>

                        <FormGroup>
                            <ControlLabel>Visibility</ControlLabel>
                            <FormControl
                                componentClass="select"
                                name="playlist_visibility"
                                value={playlist.playlist_visibility}
                                onChange={this.handleInputChange}
                                disabled={this.state.loading}
                            >
                                {playlistVisibilityOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </FormControl>
                        </FormGroup>

                        {this.renderPrivateOptions()}

                        <FormGroup>
                            <ControlLabel>Country Block</ControlLabel>
                            <br/>
                            <Switch
                                value={playlist.playlist_country_block_status === 1}
                                onChange={(el, value) => this.handleSwitch("playlist_country_block_status", value)}
                            />
                        </FormGroup>

                        {this.renderCountryBlockFields()}

                        <FormGroup>
                            <ControlLabel>Assign Tags</ControlLabel>
                            <TagsInput
                                value={playlist.playlist_tags}
                                disabled={this.state.loading}
                                onChange={this.handleTagsChange}
                                tagProps={{className: "react-tagsinput-tag tag-fill tag-azure"}}
                            />
                        </FormGroup>
                    </div>
                }
            />
        );
    }

    renderEventSelectionCard = () => (
        <Card
            content={
                <div>
                    <h5>Content Selection</h5>
                    <legend/>
                    <PlaylistScaffoldNotice title="Creator Scope">
                        Content is filtered by playlist type and the selected content creator.
                    </PlaylistScaffoldNotice>
                    <DualListBox
                        options={this.state.assignableContentOptions}
                        canFilter
                        availableLabel="Available"
                        selectedLabel="Selected"
                        showHeaderLabels
                        simpleValue={true}
                        selected={this.state.pendingContentSelection}
                        onChange={this.handleContentSelection}
                    />
                </div>
            }
        />
    );

    renderPlaylistCard = () => (
        <Card
            content={
                <div>
                    <h5>Playlist</h5>
                    <legend/>
                    {this.renderAssignedItemsTable()}
                </div>
            }
        />
    );

    renderActionBar = () => (
        <Card
            title={this.title()}
            category={this.state.playlist.playlist_name === "" ? "New playlist" : this.state.playlist.playlist_name}
            content={
                <PlaylistScaffoldNotice title="Playlist Management">
                    This screen is wired to the playlist middleware endpoints for load, save, category assignment, and item assignment.
                </PlaylistScaffoldNotice>
            }
            legend={
                <div className="buttons-with-margin">
                    <Button bsStyle="info" fill wd onClick={() => this.setState({showSaveModal: true})} disabled={this.state.loading}>
                        {this.state.loading ? "Loading..." : this.props.t("global.save", {framework: "react-i18next"})}
                    </Button>
                    <Button bsStyle="default" fill wd onClick={this.setRedirect} disabled={this.state.loading}>
                        {this.state.back_button_text}
                    </Button>
                </div>
            }
            ftTextCenter
        />
    );

    renderGeneralConfigurationCard = () => {
        const playlist = this.state.playlist;

        return (
            <Card
                content={
                    <div>
                        <h5>{this.title()} - General Settings</h5>
                        <legend/>
                        <Row>
                            <Col md={4}>
                                <FormGroup>
                                    <p className="category">Status</p>
                                    <Switch
                                        value={playlist.playlist_status === 1}
                                        onChange={(el, value) => this.handleSwitch("playlist_status", value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={8}>
                                <FormGroup>
                                    <ControlLabel>Name</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="playlist_name"
                                        value={playlist.playlist_name}
                                        onChange={this.handleInputChange}
                                        placeholder="Enter playlist name"
                                        disabled={this.state.loading}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>Slug</ControlLabel>
                                    <FormControl
                                        type="text"
                                        name="playlist_slug"
                                        value={playlist.playlist_slug}
                                        onChange={this.handleInputChange}
                                        placeholder="playlist-slug"
                                        disabled={this.state.loading}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>Position</ControlLabel>
                                    <FormControl
                                        type="number"
                                        name="playlist_position"
                                        value={playlist.playlist_position}
                                        onChange={this.handleInputChange}
                                        disabled={this.state.loading}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>Playlist Type</ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        name="playlist_type"
                                        value={playlist.playlist_type}
                                        onChange={this.handlePlaylistTypeChange}
                                        disabled={this.state.loading}
                                    >
                                        {playlistTypeOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </FormControl>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <ControlLabel>Delivery Profile</ControlLabel>
                                    <FormControl
                                        componentClass="select"
                                        name="playlist_delivery"
                                        value={playlist.playlist_delivery}
                                        onChange={this.handleInputChange}
                                        disabled={this.state.loading}
                                    >
                                        {playlistDeliveryOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </FormControl>
                                </FormGroup>
                            </Col>
                        </Row>
                        <FormGroup>
                            <ControlLabel>Description</ControlLabel>
                            <FormControl
                                componentClass="textarea"
                                name="playlist_description"
                                value={playlist.playlist_description}
                                onChange={this.handleInputChange}
                                placeholder="Describe what this playlist curates and where it appears."
                                disabled={this.state.loading}
                            />
                        </FormGroup>
                    </div>
                }
            />
        );
    }

    renderCategoriesCard = () => {
        const playlist = this.state.playlist;
        const categoryOptions = this.getFilteredCategoryOptions();

        return (
            <Card
                title="Categories"
                content={
                    <div>
                        <PlaylistScaffoldNotice title="Category Assignment">
                            Available categories are loaded from the middleware and filtered by playlist type.
                        </PlaylistScaffoldNotice>
                        <FormGroup>
                            <ControlLabel>Assigned Categories</ControlLabel>
                            <Select
                                placeholder="Select playlist categories"
                                name="playlistCategorySelect"
                                multi={true}
                                searchable={true}
                                clearable={false}
                                disabled={this.state.loading}
                                value={playlist.playlist_category_ids}
                                options={categoryOptions}
                                onChange={this.handleCategorySelection}
                            />
                        </FormGroup>
                        <div style={{marginBottom: "5px"}}>
                            {playlist.playlist_category_names.length === 0 ? "No categories selected" : playlist.playlist_category_names.map((categoryName) => (
                                <Badge key={categoryName} style={{marginRight: "6px", marginBottom: "6px", background: "#87cb16"}}>
                                    {categoryName}
                                </Badge>
                            ))}
                        </div>
                    </div>
                }
            />
        );
    }

    renderOrderingSettingsCard = () => {
        const playlist = this.state.playlist;

        return (
            <Card
                title="Ordering Settings"
                content={
                    <div>
                        <FormGroup>
                            <ControlLabel>Sort Mode</ControlLabel>
                            <FormControl
                                componentClass="select"
                                name="playlist_sort_mode"
                                value={playlist.playlist_sort_mode}
                                onChange={this.handleInputChange}
                            >
                                <option value="manual">Manual</option>
                                <option value="editorial">Editorial</option>
                                <option value="popularity">Popularity</option>
                                <option value="schedule">Schedule Driven</option>
                            </FormControl>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Max Items</ControlLabel>
                            <FormControl
                                type="number"
                                name="playlist_max_items"
                                value={playlist.playlist_max_items}
                                onChange={this.handleInputChange}
                            />
                        </FormGroup>
                        <p className="category">
                            The playlist save call persists the full item order and rule metadata in one request.
                        </p>
                    </div>
                }
            />
        );
    }

    renderViewershipRulesCard = () => {
        const playlist = this.state.playlist;

        return (
            <Card
                title="Viewership Rules"
                content={
                    <div>
                        <FormGroup>
                            <ControlLabel>Access Mode</ControlLabel>
                            <FormControl
                                componentClass="select"
                                name="playlist_viewership_mode"
                                value={playlist.playlist_viewership_mode}
                                onChange={this.handleInputChange}
                            >
                                {viewershipModeOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </FormControl>
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Audience Summary</ControlLabel>
                            <FormControl
                                type="text"
                                name="playlist_viewership_summary"
                                value={playlist.playlist_viewership_summary}
                                onChange={this.handleInputChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Geo Policy</ControlLabel>
                            <FormControl
                                type="text"
                                name="playlist_geo_policy"
                                value={playlist.playlist_geo_policy}
                                onChange={this.handleInputChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Device Targets</ControlLabel>
                            <FormControl
                                type="text"
                                name="playlist_device_targets"
                                value={playlist.playlist_device_targets}
                                onChange={this.handleInputChange}
                            />
                        </FormGroup>
                    </div>
                }
            />
        );
    }

    renderPlaylistContextCard = () => {
        const playlist = this.state.playlist;
        const supportedFormats = playlistArray.filter((item) => item.download).slice(0, 8);

        return (
            <Card
                title="Playlist Context"
                content={
                    <div>
                        <p><strong>Type:</strong> {formatPlaylistType(playlist.playlist_type)}</p>
                        <p><strong>Mode:</strong> {formatViewershipMode(playlist.playlist_viewership_mode)}</p>
                        <p><strong>Audience:</strong> {playlist.playlist_viewership_summary || "Not set"}</p>
                        <p><strong>Devices:</strong> {playlist.playlist_device_targets || "Not set"}</p>
                        <p><strong>Assigned Categories:</strong></p>
                        <div style={{marginBottom: "15px"}}>
                            {playlist.playlist_category_names.length === 0 ? "No categories selected" : playlist.playlist_category_names.map((categoryName) => (
                                <Badge key={categoryName} style={{marginRight: "6px", marginBottom: "6px", background: "#1DC7EA"}}>
                                    {categoryName}
                                </Badge>
                            ))}
                        </div>
                        <PlaylistScaffoldNotice title="Entitlements">
                            This section tracks the summary rule fields now. Package and dealer-specific selectors can layer onto the same payload later.
                        </PlaylistScaffoldNotice>
                        <p style={{marginTop: "20px"}}><strong>Supported Export Profiles:</strong></p>
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Format</th>
                                <th>OTT</th>
                                <th>IPTV</th>
                            </tr>
                            </thead>
                            <tbody>
                            {supportedFormats.map((format) => (
                                <tr key={format.id}>
                                    <td>{format.label}</td>
                                    <td>{format.value_ott}</td>
                                    <td>{format.value_iptv}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                }
            />
        );
    }

    renderAssignedContentCard = () => {
        const selectedContentValues = this.state.playlist.items.map((item) => this.getItemKey(item.content_type, item.content_id));

        return (
            <Card
                content={
                    <div>
                        <h5>Playlist Builder</h5>
                        <legend/>
                        <PlaylistScaffoldNotice title="Content Assignment">
                            Assignable content is loaded from the new playlist endpoint for the selected playlist type.
                        </PlaylistScaffoldNotice>
                        <FormGroup>
                            <ControlLabel>Selected Content</ControlLabel>
                            <Select
                                placeholder={this.state.contentLoading ? "Loading content..." : "Select content"}
                                name="playlistContentSelect"
                                multi={true}
                                searchable={true}
                                clearable={false}
                                disabled={this.state.loading || this.state.contentLoading}
                                value={selectedContentValues}
                                options={this.state.assignableContentOptions}
                                onChange={this.handleContentSelection}
                            />
                        </FormGroup>
                        {this.renderAssignedItemsTable()}
                    </div>
                }
            />
        );
    }

    renderOrderingRulesCard = () => {
        const sortedItems = this.sortItems(this.state.playlist.items);

        return (
            <Card
                title="Playlist Rules"
                content={
                    <div>
                        {sortedItems.length === 0 ? (
                            <div className="text-center" style={{padding: "20px 0"}}>
                                Add content to the playlist before setting per-item ordering rules.
                            </div>
                        ) : (
                            <table className="table">
                                <thead>
                                <tr>
                                    <th style={{width: "80px"}}>Order</th>
                                    <th>Title</th>
                                    <th style={{width: "160px"}}>Rule</th>
                                    <th style={{width: "180px"}}>Start Window</th>
                                    <th style={{width: "180px"}}>End Window</th>
                                </tr>
                                </thead>
                                <tbody>
                                {sortedItems.map((item) => {
                                    const itemKey = this.getItemKey(item.content_type, item.content_id);

                                    return (
                                        <tr key={itemKey}>
                                            <td>
                                                <FormControl
                                                    type="number"
                                                    value={item.playlist_order}
                                                    onChange={(event) => this.handlePlaylistItemChange(itemKey, "playlist_order", event.target.value)}
                                                />
                                            </td>
                                            <td>{item.content_title}</td>
                                            <td>
                                                <FormControl
                                                    componentClass="select"
                                                    value={item.ordering_rule}
                                                    onChange={(event) => this.handlePlaylistItemChange(itemKey, "ordering_rule", event.target.value)}
                                                >
                                                    {playlistOrderingRuleOptions.map((option) => (
                                                        <option key={option.value} value={option.value}>{option.label}</option>
                                                    ))}
                                                </FormControl>
                                            </td>
                                            <td>
                                                <FormControl
                                                    type="text"
                                                    value={item.start_window}
                                                    onChange={(event) => this.handlePlaylistItemChange(itemKey, "start_window", event.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <FormControl
                                                    type="text"
                                                    value={item.end_window}
                                                    onChange={(event) => this.handlePlaylistItemChange(itemKey, "end_window", event.target.value)}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                            </table>
                        )}
                    </div>
                }
            />
        );
    }

    renderNavigation = () => (
        <Card
            plain
            content={
                <div className="nav-container">
                    <Nav bsStyle="tabs" bsClass="nav nav-icons">
                        <NavItem eventKey="playlist_tab_general">
                            <i className="fa fa-sliders"/><br/>General
                        </NavItem>
                        <NavItem eventKey="playlist_tab_categories">
                            <i className="fa fa-folder-open"/><br/>Categories
                        </NavItem>
                        <NavItem eventKey="playlist_tab_assign">
                            <i className="fa fa-link"/><br/>Assign Content
                        </NavItem>
                        <NavItem eventKey="playlist_tab_ordering">
                            <i className="fa fa-sort"/><br/>Ordering
                        </NavItem>
                        <NavItem eventKey="playlist_tab_viewership">
                            <i className="fa fa-eye"/><br/>Viewership
                        </NavItem>
                    </Nav>
                </div>
            }
        />
    );

    renderGeneralTab = () => {
        const playlist = this.state.playlist;
        const supportedFormats = playlistArray.filter((item) => item.download).slice(0, 8);

        return (
            <Grid fluid>
                <Row>
                    <Col md={7}>
                        <Card
                            title="General Configuration"
                            content={
                                <div>
                                    <FormGroup>
                                        <p className="category">Status</p>
                                        <Switch
                                            value={playlist.playlist_status === 1}
                                            onChange={(el, value) => this.handleSwitch("playlist_status", value)}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <ControlLabel>Name</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="playlist_name"
                                            value={playlist.playlist_name}
                                            onChange={this.handleInputChange}
                                            placeholder="Enter playlist name"
                                            disabled={this.state.loading}
                                        />
                                    </FormGroup>
                                    <Row>
                                        <Col md={6}>
                                            <FormGroup>
                                                <ControlLabel>Slug</ControlLabel>
                                                <FormControl
                                                    type="text"
                                                    name="playlist_slug"
                                                    value={playlist.playlist_slug}
                                                    onChange={this.handleInputChange}
                                                    placeholder="playlist-slug"
                                                    disabled={this.state.loading}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <ControlLabel>Position</ControlLabel>
                                                <FormControl
                                                    type="number"
                                                    name="playlist_position"
                                                    value={playlist.playlist_position}
                                                    onChange={this.handleInputChange}
                                                    disabled={this.state.loading}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={6}>
                                            <FormGroup>
                                                <ControlLabel>Playlist Type</ControlLabel>
                                                <FormControl
                                                    componentClass="select"
                                                    name="playlist_type"
                                                    value={playlist.playlist_type}
                                                    onChange={this.handlePlaylistTypeChange}
                                                    disabled={this.state.loading}
                                                >
                                                    {playlistTypeOptions.map((option) => (
                                                        <option key={option.value} value={option.value}>{option.label}</option>
                                                    ))}
                                                </FormControl>
                                            </FormGroup>
                                        </Col>
                                        <Col md={6}>
                                            <FormGroup>
                                                <ControlLabel>Delivery Profile</ControlLabel>
                                                <FormControl
                                                    componentClass="select"
                                                    name="playlist_delivery"
                                                    value={playlist.playlist_delivery}
                                                    onChange={this.handleInputChange}
                                                    disabled={this.state.loading}
                                                >
                                                    {playlistDeliveryOptions.map((option) => (
                                                        <option key={option.value} value={option.value}>{option.label}</option>
                                                    ))}
                                                </FormControl>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <FormGroup>
                                        <ControlLabel>Description</ControlLabel>
                                        <FormControl
                                            componentClass="textarea"
                                            name="playlist_description"
                                            value={playlist.playlist_description}
                                            onChange={this.handleInputChange}
                                            placeholder="Describe what this playlist curates and where it appears."
                                            disabled={this.state.loading}
                                        />
                                    </FormGroup>
                                </div>
                            }
                        />
                    </Col>
                    <Col md={5}>
                        <Card
                            title="Playlist Context"
                            content={
                                <div>
                                    <p><strong>Assigned Categories:</strong></p>
                                    <div style={{marginBottom: "15px"}}>
                                        {playlist.playlist_category_names.length === 0 ? "No categories selected" : playlist.playlist_category_names.map((categoryName) => (
                                            <Badge key={categoryName} style={{marginRight: "6px", marginBottom: "6px", background: "#1DC7EA"}}>
                                                {categoryName}
                                            </Badge>
                                        ))}
                                    </div>
                                    <p><strong>Viewership:</strong> {playlist.playlist_viewership_summary || "Not set"}</p>
                                    <p><strong>Devices:</strong> {playlist.playlist_device_targets || "Not set"}</p>
                                    <p><strong>Supported Export Profiles:</strong></p>
                                    <table className="table">
                                        <thead>
                                        <tr>
                                            <th>Format</th>
                                            <th>OTT</th>
                                            <th>IPTV</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {supportedFormats.map((format) => (
                                            <tr key={format.id}>
                                                <td>{format.label}</td>
                                                <td>{format.value_ott}</td>
                                                <td>{format.value_iptv}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            }
                        />
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderCategoriesTab = () => {
        const playlist = this.state.playlist;
        const categoryOptions = this.getFilteredCategoryOptions();
        const columns = [
            {
                accessor: "label",
                Header: "Category",
                minWidth: 220
            },
            {
                accessor: "scope",
                Header: "Scope",
                minWidth: 130,
                Cell: (row) => formatCategoryScope(row.value)
            },
            {
                accessor: "playlist_count",
                Header: "Playlists",
                maxWidth: 90,
                Cell: (row) => <div className="center">{row.value}</div>
            }
        ];

        return (
            <Grid fluid>
                <Row>
                    <Col md={12}>
                        <Card
                            title="Category Selection"
                            content={
                                <div>
                                    <PlaylistScaffoldNotice title="Category Assignment">
                                        Available categories are loaded from the middleware and filtered by playlist type.
                                    </PlaylistScaffoldNotice>
                                    <FormGroup>
                                        <ControlLabel>Assigned Categories</ControlLabel>
                                        <Select
                                            placeholder="Select playlist categories"
                                            name="playlistCategorySelect"
                                            multi={true}
                                            searchable={true}
                                            clearable={false}
                                            disabled={this.state.loading}
                                            value={playlist.playlist_category_ids}
                                            options={categoryOptions}
                                            onChange={this.handleCategorySelection}
                                        />
                                    </FormGroup>
                                    <p><strong>Categories currently linked to this playlist:</strong></p>
                                    <div style={{marginBottom: "20px"}}>
                                        {playlist.playlist_category_names.length === 0 ? "No categories selected" : playlist.playlist_category_names.map((categoryName) => (
                                            <Badge key={categoryName} style={{marginRight: "6px", marginBottom: "6px", background: "#87cb16"}}>
                                                {categoryName}
                                            </Badge>
                                        ))}
                                    </div>
                                    <PlaylistScaffoldTable
                                        columns={columns}
                                        data={categoryOptions}
                                        loading={this.state.loading}
                                    />
                                </div>
                            }
                        />
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderAssignedItemsTable = () => {
        const playlist = this.state.playlist;
        const sortedItems = this.sortItems(playlist.items);

        if (sortedItems.length === 0) {
            return (
                <div className="text-center" style={{padding: "20px 0"}}>
                    No content selected for this playlist.
                </div>
            );
        }

        return (
            <table className="table">
                <thead>
                <tr>
                    <th style={{width: "80px"}}>Order</th>
                    <th>Title</th>
                    <th style={{width: "160px"}}>Type</th>
                    <th style={{width: "180px"}}>Availability</th>
                    <th style={{width: "180px"}}>Position Order</th>
                    <th style={{width: "160px"}}>Start Window</th>
                    <th style={{width: "160px"}}>End Window</th>
                    <th style={{width: "80px"}}>Action</th>
                </tr>
                </thead>
                <tbody>
                {sortedItems.map((item) => {
                    const itemKey = this.getItemKey(item.content_type, item.content_id);

                    return (
                        <tr key={itemKey}>
                            <td>
                                <FormControl
                                    type="number"
                                    value={item.playlist_order}
                                    onChange={(event) => this.handlePlaylistItemChange(itemKey, "playlist_order", event.target.value)}
                                />
                            </td>
                            <td>{item.content_title}</td>
                            <td>{formatPlaylistType(item.content_type)}</td>
                            <td>
                                <FormControl
                                    type="text"
                                    value={item.availability}
                                    onChange={(event) => this.handlePlaylistItemChange(itemKey, "availability", event.target.value)}
                                />
                            </td>
                            <td>
                                <FormControl
                                    componentClass="select"
                                    value={item.ordering_rule}
                                    onChange={(event) => this.handlePlaylistItemChange(itemKey, "ordering_rule", event.target.value)}
                                >
                                    {playlistOrderingRuleOptions.map((option) => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </FormControl>
                            </td>
                            <td>
                                <FormControl
                                    type="text"
                                    value={item.start_window}
                                    onChange={(event) => this.handlePlaylistItemChange(itemKey, "start_window", event.target.value)}
                                />
                            </td>
                            <td>
                                <FormControl
                                    type="text"
                                    value={item.end_window}
                                    onChange={(event) => this.handlePlaylistItemChange(itemKey, "end_window", event.target.value)}
                                />
                            </td>
                            <td>
                                <Button bsStyle="danger" simple icon onClick={() => this.removePlaylistItem(itemKey)}>
                                    <i className="fa fa-times"/>
                                </Button>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </table>
        );
    }

    renderAssignContentTab = () => {
        const selectedContentValues = this.state.playlist.items.map((item) => this.getItemKey(item.content_type, item.content_id));

        return (
            <Grid fluid>
                <Row>
                    <Col md={12}>
                        <Card
                            title="Assigned Content"
                            content={
                                <div>
                                    <PlaylistScaffoldNotice title="Content Assignment">
                                        Assignable content is loaded from the new playlist endpoint for the selected playlist type.
                                    </PlaylistScaffoldNotice>
                                    <FormGroup>
                                        <ControlLabel>Selected Content</ControlLabel>
                                        <Select
                                            placeholder={this.state.contentLoading ? "Loading content..." : "Select content"}
                                            name="playlistContentSelect"
                                            multi={true}
                                            searchable={true}
                                            clearable={false}
                                            disabled={this.state.loading || this.state.contentLoading}
                                            value={selectedContentValues}
                                            options={this.state.assignableContentOptions}
                                            onChange={this.handleContentSelection}
                                        />
                                    </FormGroup>
                                    {this.renderAssignedItemsTable()}
                                </div>
                            }
                        />
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderOrderingTab = () => {
        const playlist = this.state.playlist;
        const sortedItems = this.sortItems(playlist.items);

        return (
            <Grid fluid>
                <Row>
                    <Col md={8}>
                        <Card
                            title="Ordering Rules"
                            content={
                                <div>
                                    {sortedItems.length === 0 ? (
                                        <div className="text-center" style={{padding: "20px 0"}}>
                                            Add content on the Assign Content tab before setting item ordering rules.
                                        </div>
                                    ) : (
                                        <table className="table">
                                            <thead>
                                            <tr>
                                                <th style={{width: "80px"}}>Order</th>
                                                <th>Title</th>
                                                <th style={{width: "160px"}}>Rule</th>
                                                <th style={{width: "180px"}}>Start Window</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {sortedItems.map((item) => {
                                                const itemKey = this.getItemKey(item.content_type, item.content_id);

                                                return (
                                                    <tr key={itemKey}>
                                                        <td>
                                                            <FormControl
                                                                type="number"
                                                                value={item.playlist_order}
                                                                onChange={(event) => this.handlePlaylistItemChange(itemKey, "playlist_order", event.target.value)}
                                                            />
                                                        </td>
                                                        <td>{item.content_title}</td>
                                                        <td>
                                                            <FormControl
                                                                componentClass="select"
                                                                value={item.ordering_rule}
                                                                onChange={(event) => this.handlePlaylistItemChange(itemKey, "ordering_rule", event.target.value)}
                                                            >
                                                                {playlistOrderingRuleOptions.map((option) => (
                                                                    <option key={option.value} value={option.value}>{option.label}</option>
                                                                ))}
                                                            </FormControl>
                                                        </td>
                                                        <td>
                                                            <FormControl
                                                                type="text"
                                                                value={item.start_window}
                                                                onChange={(event) => this.handlePlaylistItemChange(itemKey, "start_window", event.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            }
                        />
                    </Col>
                    <Col md={4}>
                        <Card
                            title="Playlist Ordering"
                            content={
                                <div>
                                    <FormGroup>
                                        <ControlLabel>Sort Mode</ControlLabel>
                                        <FormControl
                                            componentClass="select"
                                            name="playlist_sort_mode"
                                            value={playlist.playlist_sort_mode}
                                            onChange={this.handleInputChange}
                                        >
                                            <option value="manual">Manual</option>
                                            <option value="editorial">Editorial</option>
                                            <option value="popularity">Popularity</option>
                                            <option value="schedule">Schedule Driven</option>
                                        </FormControl>
                                    </FormGroup>
                                    <FormGroup>
                                        <ControlLabel>Max Items</ControlLabel>
                                        <FormControl
                                            type="number"
                                            name="playlist_max_items"
                                            value={playlist.playlist_max_items}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                    <p className="category">
                                        The playlist save call persists the full item order and rule metadata in one request.
                                    </p>
                                </div>
                            }
                        />
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderViewershipTab = () => {
        const playlist = this.state.playlist;

        return (
            <Grid fluid>
                <Row>
                    <Col md={7}>
                        <Card
                            title="Viewership Rules"
                            content={
                                <div>
                                    <FormGroup>
                                        <ControlLabel>Access Mode</ControlLabel>
                                        <FormControl
                                            componentClass="select"
                                            name="playlist_viewership_mode"
                                            value={playlist.playlist_viewership_mode}
                                            onChange={this.handleInputChange}
                                        >
                                            {viewershipModeOptions.map((option) => (
                                                <option key={option.value} value={option.value}>{option.label}</option>
                                            ))}
                                        </FormControl>
                                    </FormGroup>
                                    <FormGroup>
                                        <ControlLabel>Audience Summary</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="playlist_viewership_summary"
                                            value={playlist.playlist_viewership_summary}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <ControlLabel>Geo Policy</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="playlist_geo_policy"
                                            value={playlist.playlist_geo_policy}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <ControlLabel>Device Targets</ControlLabel>
                                        <FormControl
                                            type="text"
                                            name="playlist_device_targets"
                                            value={playlist.playlist_device_targets}
                                            onChange={this.handleInputChange}
                                        />
                                    </FormGroup>
                                </div>
                            }
                        />
                    </Col>
                    <Col md={5}>
                        <Card
                            title="Rule Preview"
                            content={
                                <div>
                                    <p><strong>Type:</strong> {formatPlaylistType(playlist.playlist_type)}</p>
                                    <p><strong>Mode:</strong> {formatViewershipMode(playlist.playlist_viewership_mode)}</p>
                                    <p><strong>Audience:</strong> {playlist.playlist_viewership_summary || "Not set"}</p>
                                    <p><strong>Geo:</strong> {playlist.playlist_geo_policy || "Not set"}</p>
                                    <p><strong>Devices:</strong> {playlist.playlist_device_targets || "Not set"}</p>
                                    <PlaylistScaffoldNotice title="Entitlements">
                                        This tab now saves the summary rule fields. Package and dealer-specific selectors can be added on top of the same payload later.
                                    </PlaylistScaffoldNotice>
                                </div>
                            }
                        />
                    </Col>
                </Row>
            </Grid>
        );
    }

    render() {
        return (
            <div className="main-content">
                <NotificationSystem ref="notificationSystem" style={style}/>
                {this.renderRedirect()}
                {this.renderSaveModal()}
                <Grid fluid>
                    <Row>
                        <Col md={5}>
                            {this.renderPlaylistInformationCard()}
                            {this.renderEventSelectionCard()}
                        </Col>
                        <Col md={7}>
                            {this.renderPlaylistCard()}
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const {authentication} = state;
    const {user} = authentication;

    return {
        user
    };
}

const connectedEditPlaylist = connect(mapStateToProps)(EditPlaylist);
const connectedEditPlaylistTrans = withNamespaces("common")(connectedEditPlaylist);
export const PlaylistEditScaffold = EditPlaylist;
export const EditPlaylistTrans = connectedEditPlaylistTrans;
export {connectedEditPlaylistTrans as EditPlaylist};
